import React, { useContext, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import AdvancedSearchDropdown from '../../../components/dropdown';

import { useSortedTranslatedCountries } from '../../../../hooks/use-sorted-translated-countries';
import { AdvancedSearchShipmentContext } from '../../context';
import { id } from '../../../../filters/options/country';
import { isOperator } from '../../../../filters/operators/collection';

import messages from '../messages';

import baseStyle from '../../../style.module.less';

const defaultOption = {
  id: 'DEFAULT_OPTION',
  apiKey: 'DEFAULT_OPTION',
  component: <FormattedMessage {...messages.selectOne} />,
};

const CountryFilter = () => {
  const countries = useSortedTranslatedCountries();

  const allOptions = useMemo(() => {
    const countryOptions = countries.map((country) => {
      return {
        id: country.code,
        apiKey: country.code,
        component: country.label,
      };
    });
    return [defaultOption, ...countryOptions];
  }, [countries]);

  const { filters, updateFilter, clearFilter } = useContext(AdvancedSearchShipmentContext);

  const { value: [value = defaultOption.apiKey] = [] } = filters.find((filter) => filter.id === id) || {};
  const selectedCountry = allOptions.find((opt) => opt.apiKey === value);

  const onOptionSelected = useCallback(
    (option) => {
      if (option.id === defaultOption.id) {
        clearFilter(id);
        return;
      }
      updateFilter(id, [option.apiKey], isOperator);
    },
    [updateFilter, clearFilter],
  );

  return (
    <span className={baseStyle.filterInput}>
      <label className={baseStyle.filterLabel}>
        <FormattedMessage {...messages.country} />
      </label>
      <AdvancedSearchDropdown onOptionSelected={onOptionSelected} options={allOptions} selectedId={selectedCountry.id} />
    </span>
  );
};

export default CountryFilter;
